module.exports = __webpack_public_path__ + "static/media/joey.e24d127b.jpg";